<template>
    <inertia-link class="px-3 py-2 md:px-4 md:py-2 font-medium uppercase leading-5 text-white bg-purple-600 rounded border border-transparent active:bg-purple-600 hover:bg-purple-700 focus:outline-none focus:shadow-outline-gray whitespace-no-wrap" :href="href">
        <slot />
    </inertia-link>
</template>

<script>
export default {
    name: "BtnLink",
    props: {
        href: {
            type: String,
            default: route('players.index'),
        },
    }
}
</script>

<style scoped>

</style>
